import { addBreadcrumb } from '@/services/observability/sentryClient';

/**
 * Minimal app logger (spec §4). Console output is dev-only; the breadcrumb
 * always forwards through the Sentry seam (no-op until RES-109) so silent
 * catches become visible in crash context without changing behavior.
 * Deliberately tiny: no transports, no levels config.
 */
const emit = (level: 'warn' | 'error', label: string, error?: unknown): void => {
  try {
    if (__DEV__) {
      // eslint-disable-next-line no-console
      console[level](`[${label}]`, error);
    }
    addBreadcrumb({
      category: 'silent.catch',
      message: label,
      level: 'info',
      data: { error: String(error) },
    });
  } catch {
    // intentional: logger must never throw
  }
};

export const logger = {
  warn: (label: string, error?: unknown) => emit('warn', label, error),
  error: (label: string, error?: unknown) => emit('error', label, error),
};
